//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { Toast } from 'mint-ui'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'UsersList',
  data() {
    return {
      show: false,
      form: {
        question: '',
        mobile: ''
      },
      startDate: '',
      nickname: '',
      endDate: '',
      list: [],
      total: 0,
      locked: 0,
      packageMap: {
        onemonth: '壹個月',
        threemonth: '三個月',
        oneyear: '壹年',
        halfyear: '半年',
        twoyear: '兩年',
        threeyear: '三年',
        fiveyear: '五年',
        other: '其他'
      },
      typeCount: {}
    }
  },
  components: {
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
    this.getUsersByDoctorId()
  },
  methods: {
    handleConfirm (key) {
      return () => {
        this[key] = value
      }
    },
    submit () {
      const body = Object.assign({}, this.form)
      if (!this.form.question) {
        return Toast({
          message: '問題',
          duration: 3000
        })
      }
      if (!this.form.mobile) {
        return Toast({
          message: '請填寫聯系方式',
          duration: 3000
        })
      }
      this.$store.httpDispatch({})('addDoctorQuestion', body).then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          this.show = false
          this.form.mobile = ''
          this.form.question = ''
          Toast({
            message: '提交成功',
            duration: 3000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getDate (createdAt) {
      return moment(createdAt).format('YY-MM-DD')
    },
    openPicker(key) {
      this.$refs[key].open()
    },
    getUsersByDoctorId () {
      if (
        (this.startDate && !this.endDate) ||
        (!this.startDate && this.endDate)
      ) {
        return Toast({
          message: '請選擇開始時間與結束時間',
          duration: 5000
        })
      }
      this.$store.httpDispatch({})('addLog', {
        action: '查看',
        type: '用戶列表',
        from: 'client',
        content: '查看用戶列表'
      }).catch((err) => {
        console.log(err)
      })
      this.$store.httpDispatch({
      })('getUsersByDoctorId', {
        startDate: this.startDate ? new Date(this.startDate).toISOString() : '',
        endDate: this.endDate ? new Date(this.endDate).toISOString() : '',
        nickname: this.nickname
      })
      .then((res) => {
        console.log(res.data)
        if (res.data.code === 0) {
          this.list = res.data.data.users
          this.total = res.data.data.total
          this.locked = res.data.data.locked
          this.typeCount = res.data.data.typeCount
        }
      })
    }
  }
}
